<template>
    <div class="backoffice-trainers-view backoffice-members-view">
        <div class="grid">
            <v-card class="menu" elevation="1">
                <div class="user-info">
                    <v-menu bottom left>
                        <template v-slot:activator="{ on, attrs }">
                            <v-icon v-bind="attrs" v-on="on" class="menu-dots">mdi-dots-vertical</v-icon>
                        </template>
                        <v-list expand nav dense>
                             <v-list-item @click="sendInvitation()" link v-show="$page.props.p['members.manage'] && !$page.props.trainer.user_id">
                                <v-list-item-title>{{ $page.props.lang.send_invitation || "Send invitation" }}</v-list-item-title>
                                <v-list-item-icon><v-icon>mdi-email-outline</v-icon></v-list-item-icon>
                            </v-list-item>
                            <v-list-item @click="disableEnableTrainer()" link v-if="$page.props.p['members.manage'] && trainerData.is_active">
                                <v-list-item-title>{{ $page.props.lang.disable_trainer || "Disable tariner" }}</v-list-item-title>
                                <v-list-item-icon><v-icon>mdi-account-remove</v-icon></v-list-item-icon>
                            </v-list-item>
                            <v-list-item @click="disableEnableTrainer()" link v-if="$page.props.p['members.manage'] && !trainerData.is_active">
                                <v-list-item-title>{{ $page.props.lang.enable_trainer || "Enable tariner" }}</v-list-item-title>
                                <v-list-item-icon><v-icon>mdi-account-check</v-icon></v-list-item-icon>
                            </v-list-item>
                        </v-list>
                    </v-menu>

                    <ConfirmModal :open="deleteMembModal"
                    @no.once="deleteMembModal = false" 
                    @yes.once="deleteMember" 
                    @close.once="deleteMembModal = false" 
                    @closed="deleteMembModal = false"
                    :description="$page.props.lang.deleteMemberConfirmDescription || 'Are You sure You want to delete this trainer?'">
                    </ConfirmModal>

                    <div class="image-wrap">
                        <v-progress-circular v-show="imageLoading" class="image-loader" indeterminate color="primary"></v-progress-circular>
                        <img :src="trainerData.profile_photo_url + '?w=220'" alt="" width="110" height="110">
                        <div class="upload" v-show="$page.props.p['members.manage']">
                            <v-file-input
                            v-model="trainerPhoto"
                            prepend-icon="mdi-camera-outline"
                            @change="onFileChange">
                            </v-file-input>
                        </div>
                    </div>
                    <div class="user">
                        <h3 class="name">{{ trainerData.first_name + ' ' + trainerData.last_name}}</h3>
                        <p class="email">{{ trainerData.email }}</p>
                    </div>
                </div>
                <v-divider/>
                <v-list expand nav dense>
                    <inertia-link :href="'/backoffice/trainers/details/'+$page.props.trainer.id">
                        <v-list-item link :class="{'v-list-item--active' : $page.props.currentRouteName.startsWith('backoffice.trainers.details')}">
                            <v-list-item-icon><v-icon>mdi-account-details-outline</v-icon></v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>{{ $page.props.lang.details || "Details" }}</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </inertia-link>
                     <inertia-link :href="'/backoffice/trainers/details/' + $page.props.trainer.id + '/schedule'">
                        <v-list-item link :class="{'v-list-item--active' : $page.props.currentRouteName.startsWith('backoffice.trainers.schedule')}">
                            <v-list-item-icon><v-icon>mdi-clock-check-outline</v-icon></v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>{{ $page.props.lang.schedule || "Schedule" }}</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </inertia-link>
                    <inertia-link :href="'/backoffice/trainers/details/'+$page.props.trainer.id+'/permissions'">
                        <v-list-item link :class="{'v-list-item--active' : $page.props.currentRouteName.startsWith('backoffice.trainers.permissions')}">
                            <v-list-item-icon><v-icon>mdi-check-box-outline</v-icon></v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>{{ $page.props.lang.permissions || "Permissions" }}</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </inertia-link>
                </v-list>
            </v-card>
            <v-card class="panel account" @edited="editedTrainer" elevation="1">
                <slot></slot>
            </v-card>
        </div>
    </div>
    
</template>

<script>
import ConfirmModal from '@/js/Components/ConfirmModal'
import EventBus from '@/js/eventbus'

export default {
	components: {
		ConfirmModal
	},
	data() {
		return {
			deleteMembModal: false,
            trainerData: this.$page.props.trainer,
            trainerPhoto: null,
            trainerPhotoUrl: this.$page.props.trainer.profile_photo_url + '?w=220',
            messageObjects: [],
            imageLoading: false
		}
	},
    methods: {
		editedTrainer(value) {
			this.trainerData = Object.assign({}, value)
		},
        disableEnableTrainer(){

            axios.post('/backoffice/trainers/disable', {id: this.$page.props.trainer.id})
                .then(r => {
                    var messageType = "success";
                    if(r.data.status === "OK") {
                        this.trainerData = Object.assign({}, r.data.trainer);
                    }else{
                        messageType = "error";
                    }

                     EventBus.$emit('SHOW_NOTIFICATION',{ 
                                message: r.data.message,
                                color: messageType,
                                timeout: 5000
                            });

                })
                .catch(e => {

                });

        },
        onFileChange() {
            if(this.trainerPhoto) {
                this.imageLoading = true
                let file =  this.trainerPhoto
                const config = {
                    headers: { 'content-type': 'multipart/form-data' }
                }
                let formData = new FormData()
                formData.append('photo', file)
                formData.append('member_id', this.$page.props.trainer.id)
                axios.post('/backoffice/members/uploadphoto', formData, config)
                    .then(response => {

                        this.imageLoading = false;

                        var messageType = "success";
                        if (response.data.status !="OK") {
                            var messageType = "error";
                        }else{
                            this.trainerData.profile_photo_url = response.data.photo_path;
                        }

                        EventBus.$emit('SHOW_NOTIFICATION',{
                                message: response.data.message,
                                color: messageType,
                                timeout: 5000
                            });
                    })
                    .catch(e => {

                        this.imageLoading = false;

                        if(e) {
                           
                            EventBus.$emit('SHOW_NOTIFICATION',{ 
                                    message: e.response.data.message,
                                    color: 'error',
                                    timeout: 10000
                                })
                        }
                    });
            }
        },
        sendInvitation(){
            axios.post('/backoffice/trainers/sendinvitation', {id: this.$page.props.trainer.id})
                .then(response => {
                    if(response.data.status==="OK"){
                        EventBus.$emit('SHOW_NOTIFICATION',{
                                message: response.data.message,
                                color: 'success',
                                timeout: 5000
                            })
                    }
                })
                .catch(error => {
                  
                    EventBus.$emit('SHOW_NOTIFICATION',{ 
                            message: 'Internal server error!',
                            color: 'error',
                            timeout: 10000
                        })
                })
        },
        deleteMember() {
            axios.post('/backoffice/members/delete', {id: this.$page.props.trainer.id})
                .then(response => {
                    if(response.data.status==="OK") {
                        this.$inertia.visit('/backoffice/trainers', {method: 'get'})
                    }
                })
                .catch(error => {
                    
                    EventBus.$emit('SHOW_NOTIFICATION',{
                            message: this.$page.props.lang.deleteMemberError || 'Member is not deleted',
                            color: 'error',
                            timeout: 10000
                        })
                })
		},
    }
}
</script>